import React, { createContext, useContext, useEffect, useState } from "react";
import useAxios from "../adapter/useAxios";
import useSecurity from "../hooks/useSecurity";
import { ConfigContext } from "../security/ConfigContext";

const BANNERS_REFRESH_INTERVAL = 60000;

const initialState = {
  banners: [],
  getBanners: () => {},
  onAddBanner: (_banner) => {},
  onDeleteBanner: (_bannerId) => {},
  onUpdateBanner: (_banner) => {},
  bannerMessage: "",
  _setBannerMessage: (_message) => {},
};

export const BannerContext = createContext(initialState);
BannerContext.displayName = "BannerContext";

export const BannerContextProvider = ({ children }) => {
  const [config] = useContext(ConfigContext);
  const { isAuthenticated, getAccessToken } = useSecurity();
  const { get, post, deleteReq, put } = useAxios();
  const [banners, setBanners] = useState(initialState.banners);
  const [bannerMessage, setBannerMessage] = useState(initialState.bannerMessage);

  const _setBannerMessage = (message) => {
    setBannerMessage(message);
  };

  const getBanners = () => {
    return get({
      url: config.apiUrls.banners,
    })
      .then((response) => {
        setBanners(response || [])
      })
      .catch((error) => {
        console.log(error);
        setBannerMessage("Network error");
      });
  };

  const onAddBanner = (banner) => {
    return post({
      url: config.apiUrls.banners,
      data: banner,
    })
      .then(() => {
        getBanners();
        setBannerMessage("Banner added successfully");
      })
      .catch((error) => {
        console.log(error);
        setBannerMessage("Network error");
      });
  };

  const onDeleteBanner = (bannerId) => {
    return deleteReq({
      url: `${config.apiUrls.banners}/${bannerId}`,
    })
      .then(() => {
        getBanners();
        setBannerMessage("Banner deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        setBannerMessage("Network error");
      });
  };

  const onUpdateBanner = (banner) => {
    return put({
      url: `${config.apiUrls.banners}/${banner._id}`,
      data: banner,
    })
      .then(() => {
        getBanners();
        setBannerMessage("Banner updated successfully");
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    getBanners();
    const interval = setInterval(getBanners, BANNERS_REFRESH_INTERVAL);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, getAccessToken]);

  return (
    <BannerContext.Provider
      value={{
        banners,
        getBanners,
        onAddBanner,
        onDeleteBanner,
        onUpdateBanner,
        bannerMessage,
        _setBannerMessage,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};
